<template>
<div>
  <div class="box-header title-boreder">
      <h3 class="box-title title"> Inventario por Estado</h3>
  </div>
  <div class="box box-success">
     <div class="box-header title-boreder" v-if="fetchData !== null">
       <h3 class="box-title box-title-sub"><i class="Inventory-icon" style="padding-bottom:20px;"></i> INVENTARIO AL {{fetchData.inventoryDate | formatDate('L')}}</h3>
     </div>
     <div class="box-body">
      <div class="row">
        <div class="col-md-6">
          <div id="divAccountSelect" class="form-group">
            <label>Cuenta</label>  
            <multiselect
              :value="this.selectedAccount"
              selectLabel=""
              selectedLabel=""
              deselectLabel=""
              track-by="name"
              :placeholder="this.selectedAccount.name"
              :allow-empty="false"
              label="name"
              :options="this.optionsAccount"
              @input="onAccountSelect">
              <span slot="noResult">
                No se encontraron resultados
              </span>
            </multiselect>
          </div>
        </div>
        <div class="col-md-6">
          <div id="divInvProductSelect" class="form-group">
            <label>Producto</label>  
            <multiselect
              :value="this.selectedProduct"
              selectLabel="Seleccionar producto"
              selectedLabel="Producto seleccionado"
              deselectLabel=""
              track-by="code"
              :placeholder="this.selectedProduct.text"
              :allow-empty="false"
              label="text"
              :options="optionsProducts"
              @input="onProductSelect">
              <span slot="noResult">
                No se encontraron resultados. Considere cambiar los datos de busqueda
              </span>
            </multiselect>
          </div>
        </div>
        <!-- <div class="col-md-2">
          <div class="form-group pull-left" style="padding-top:25px;">
              <button class="btn btn-success btnAction" @click="search()">Buscar</button>
            </div>
        </div> -->
      </div>
      <div class="row">
        <div class="col-md-6">
          <div style="position: relative;" v-if="chartStatusData !== null">
            <div id='asd'>
              <chart-status id="statusChart"  :chart-data="chartStatusData" style="width:60%">
              </chart-status>
            </div>
            <div style="position: absolute; right: 7%; top: 12px;" v-if="fetchData && fetchData.inventoryDate && !isNaN(fetchData.availablePercentage)">
              <table class="arkano-chart-legend">
                 <td><span style="background-color: #009d00; border-radius: 50%; display: inline-block; width: 1em; height: 1em; line-height: 1em;margin: 7px">&nbsp;</span></td>
                  <td>&nbsp;Disponible:&nbsp;</td>
                  <td style="font-weight: bold;">{{formatPercentage(fetchData.availablePercentage)}}</td>
                <template v-for="(state, stateIndex) in fetchData.states">
                  <tr v-bind:key="stateIndex" v-if="!state.isAvailable">
                    <td><span :style="'background-color: ' + state.stateColor + '; border-radius: 50%; display: inline-block; width: 1em; height: 1em; line-height: 1em;margin: 7px'">&nbsp;</span></td>
                    <td>&nbsp;{{state.state}}:&nbsp;</td>
                    <td style="text-align: right;font-weight: bold;">{{formatPercentage(state.percentageFromTotal)}}</td>
                  </tr>
                </template>
              </table>
            </div>
            <div id="centroGrafico" class="text-center summary-inner" v-bind:data-rHeight="this.realChartHeight" v-bind:style="this.summaryInnerStyle()" v-if="fetchData && fetchData.inventoryDate && !isNaN(fetchData.availablePercentage)">
              <div v-bind:style="this.summaryInnerInnerStyle()">
                <div class="series-summary" style="color: #009d00" >
                  <h4>{{formatAmount(fetchData.available)}} <span style="font-size:14px">{{fetchData.minimumStockUnit}}</span></h4>
                  <h4>({{formatPercentage(fetchData.availablePercentage)}})</h4>
                  Disponible
                </div>
                <div class="series-summary" style="color: #00224c" >
                  <h4>{{formatAmount(fetchData.unAvailable)}} <span style="font-size:14px">{{fetchData.minimumStockUnit}}</span></h4>
                  <h4>({{formatPercentage(fetchData.unAvailablePercentage)}})</h4>
                  No Disponible
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div id="divDetalle" v-if="tableStatusData !== null">
            <strong class="box-title">DETALLE POR ESTADO</strong>
            <table-status 
              id="statusTable"
              ref="vuetable"
              :api-mode="false"
              :fields="tableStatusFields"
              :data="tableStatusData"
              :css="tableCSS.table"
              style="margin-top:20px"
              @vuetable:row-clicked="onClick"
              @vuetable:loading="onLoading"        
              @vuetable:loaded="onLoaded"
              pagination-path="pagination"
              @vuetable:pagination-data="onPaginationData"
              noDataTemplate="No se encontraron resultados"
              detail-row-component="table-detail"   
              track-by="statusName">
              <template slot="statusName" scope="props">
                <span :style="'font-weight: bold;'" >{{props.rowData.statusName}}</span>
              </template>
              <template slot="quantity" scope="props">
                <span :style="'color: ' + props.rowData.color">{{formatAmount(props.rowData.statusQuantity)}}<span style="font-size:12px"> {{fetchData.minimumStockUnit}}</span></span>
              </template>
              <template slot="percentage" scope="props">
                <span :style="'color: ' + props.rowData.color">{{formatPercentage(props.rowData.percentageFromTotal)}}</span>
                &nbsp; <img src="/static/img/arrow-logo.png">
              </template>  
            </table-status>
            <div class="row">
              <div class="col-md-6">
                <template v-if="this.paginationData && paginationData.total > 0">
                  <strong style="color: #364A5D; paddin-left:15px;">
                    Mostrando documento {{ this.paginationData.from }} a {{ this.paginationData.to }} de {{ this.paginationData.total }} en Total
                  </strong>
                </template>
              </div>
              <div class="col-md-6">
                <vuetable-pagination ref="pagination"
                  :css="tableCSS.pagination"
                  @vuetable-pagination:change-page="onChangePage">
                </vuetable-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <br/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <br/>
        </div>
      </div>
    </div>
  </div>
 </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { Vuetable, VuetablePagination } from 'vuetable-2'
import DoughnutChart from 'charts/DoughnutChart.js'
import constants from 'assets/js/constants.js'
import InventoryProductStatusLine from './InventoryProductStatusLine.vue'

Vue.component('table-detail', InventoryProductStatusLine)

export default {
  name: 'InventoryProductStatus',
  components: {
    Multiselect,
    'chart-status': DoughnutChart,
    'table-status': Vuetable,
    'vuetable-pagination': VuetablePagination
  },
  data () {
    return {
      loader: null,
      selectedAccount: null,
      selectedProduct: {code: '', text: 'Todos'},
      optionsAccount: null,
      optionsProducts: [],
      chartStatusData: null,
      tableStatusData: null,
      tableDetailData: null,
      tableStatusFields: [
        {
          name: '__slot:statusName',
          title: 'Estado'
        },
        {
          name: '__slot:quantity',
          title: 'Cantidad'
        },
        {
          name: '__slot:percentage',
          title: '%'
        }
      ],
      tableCSS: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered'
        }
      },
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      },
      titleStatus: '',
      titleStatusColor: '',
      titleDetail: '',
      paginationData: null,
      fetchData: {
        inventoryDate: new Date()
      },
      realChartHeight: 0
    }
  },
  computed: {
    ...mapGetters([
      'userClients'
    ])
  },
  created () {
    this.optionsAccount = Array.from(this.userClients)
    this.selectedAccount = this.optionsAccount[0]
    this.getProducts()
    this.loadProductStatusData()
  },
  methods: {
    ...mapActions([
      'fetchInventoryProductStatusList',
      'getItemsForInventory',
      'searchDocumentPage'
    ]),
    loadProductStatusData () {
      this.loader = this.$loading.show({
        loader: 'dots'
      })

      this.fetchData = null
      this.tableStatusData = null
      this.tableDetailData = null

      let params = {
        accountCode: this.selectedAccount.code,
        code: this.selectedProduct.code
      }
      this.fetchInventoryProductStatusList(params)
      .then((data) => {
        if (data != null) {
          data.states.forEach((state) => {
            state.lines.forEach((line) => {
              line.percentageFromTotal = (100 * line.quantity) / state.quantity
              line.minimumStockUnit = data.minimumStockUnit
            })
          })

          this.fetchData = data
          this.loadChartData()
          this.loader.hide()
        }
      })
    },
    loadChartData () {
      let vueContext = this

      this.chartStatusData = {
        labels: [
          'Disponible'
        ],
        datasets: [
          {
            backgroundColor: [constants.colorPalette.baseGreen],
            data: [this.fetchData.availablePercentage]
          }
        ],
        centerTextValue: '',
        postRender (chart) {
          let currentRealChartHeight = chart.chart.height

          if (currentRealChartHeight !== vueContext.realChartHeight) {
            vueContext.realChartHeight = currentRealChartHeight
          }
        }
      }

      this.fetchData.states.forEach(state => {
        if (!state.isAvailable) {
          this.chartStatusData.labels.push(state.state)
          this.chartStatusData.datasets[0].data.push(state.percentageFromTotal)
          this.chartStatusData.datasets[0].backgroundColor.push(state.stateColor)
        }
      })

      this.loadTableStatus()
      this.selectedSection('No Disponible')
    },
    loadTableStatus () {
      this.tableStatusData = null
      this.tableDetailData = null

      this.tableStatusData = []

      this.fetchData.states.forEach(element => {
        this.tableStatusData.push(
          {
            statusName: element.state,
            statusQuantity: element.quantity,
            percentageFromTotal: element.percentageFromTotal,
            color: element.stateColor,
            lines: element.lines
          }
        )
      })
    },
    loadTableDetail (statusName) {
      this.titleDetail = statusName

      this.tableDetailData = []

      this.fetchData.states.forEach(element => {
        if (element.state === statusName) {
          element.lines.forEach(line => {
            this.tableDetailData.push(
              {
                productName: line.line,
                productQuantity: line.quantity
              }
            )
          })
        }
      })
    },
    /* DropDownList Events */
    getProducts () {
      this.getItemsForInventory(this.selectedAccount.code).then((response) => {
        this.optionsProducts = [
          {code: '', text: 'Todos'},
          ...response]
      })
    },
    nameWithLang ({ code, text }) {
      return `${code} — ${text}`
    },
    onAccountSelect (account) {
      this.selectedAccount = account
      this.getProducts()
      this.loadProductStatusData()
    },
    onProductSelect (product) {
      this.selectedProduct = product
      this.loadProductStatusData()
    },
    /* Pie Char Events */
    selectedSection (selected) {
      this.loadTableStatus()
    },
    /* Table Events */
    onLoading () {
      this.loader = this.$loading.show({
        loader: 'dots'
      })
    },
    onLoaded () {
      this.loader.hide()

      if (this.$route.params.tracking && !this.loadeadBack) {
        this.loadeadBack = true
        this.$refs.vuetable.changePage(this.documentSearch.page)
      }
    },
    onClick (data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.statusName)
    },
    renderQuantityField (value, param2) {
      return `<span class="color">${value}</span>`
    },
    chartRendered (event) {
    },
    summaryInnerStyle () {
      return {
        position: 'absolute',
        left: '0px',
        right: '0px',
        width: '60%',
        top: (this.realChartHeight / 6) + 'px'
      }
    },
    summaryInnerInnerStyle  () {
      return {
        backgroundColor: 'white',
        margin: '8px auto',
        borderRadius: '50%',
        height: (this.realChartHeight / 1.6) + 'px',
        width: (this.realChartHeight / 1.6) + 'px',
        overflow: 'hidden',
        padding: '30px 30px 30px 30px'
      }
    },   /* Table Pagination */
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.paginationData = paginationData
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
      this.searchDocumentPage(page)
    },
    dataManager (sortOrder, pagination) {
      let data = []

      if (this.tableData) {
        data = this.tableData.data

        pagination = this.$refs.vuetable.makePagination(data.length)
        data = data.slice(pagination.from - 1, pagination.to)
      } else {
        pagination = this.$refs.vuetable.makePagination(0)
      }

      return {
        pagination: pagination,
        data: data
      }
    },
    formatAmount (value) {
      return this.$options.filters.formatAmount(value)
    },
    formatPercentage (value) {
      return this.$options.filters.formatPercentage(value) + '%'
    }
  },
  destroyed () {
    if (this.loader !== null) {
      this.loader.hide()
    }
  }
}
</script>

<style>

#statusTable tbody tr {
  cursor: pointer;
}

.row .series-summary {
  border-bottom:none;
  height: 85px;
}

.row .series-summary:first-child {
  box-shadow: 0px 24px 3px -24px #4472C4;
  /* border-bottom:  #4472C4 1px solid; */
}

.series-summary {
  cursor: pointer;
  font-size: 1em;
}

.rowDisponible{
  display: inline-grid;
}

/* #divAccountSelect .multiselect{
  width: 70% !important;
} */

.series-summary:hover {
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
}

.status-line th {
  background-color: #00B000 !important;
}

.arkano-chart-legend TD {
  padding: 0.0em;  
}

.chartjs-tooltip{
  width: 98px !important;
  height: 40px !important;
}

#statusChart .chartjs-render-monitor{
  width: 100% !important;
}

.Inventory-icon::before{
  content: url("/static/img/icons/inventario.png");
}

@media screen and (max-width: 1100px) {
  #centroGrafico{
    display:none;
  }
 
  #statusChart #doughnut-chart{
    height: 500px !important;
    margin-left: 40px !important;
  }

}
</style>



// WEBPACK FOOTER //
// InventoryProductStatus.vue?2e75456c